import { State } from '../enums/state.enum';

import { IRegionState } from './region-state';


export interface IRegion {
  readonly id: number;
  state?: State;
  name?: string;
  additionalPovertyGuidline?: number;
  modifyDate?: Date | string;
  regionStates?: IRegionState[];
}
